<div class="inventory-modal">
  <div class="inventory-modal__header">
    <span class="inventory-modal__title">{{'WearTek+ System Part Numbering and Description' | translate | async}} </span>
    <i class="material-icons inventory-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>

  <div class="inventory-modal__body">

    <div class="body">


      <!-- <mat-form-field class="search-input">
        <mat-select (selectionChange)="makeChanged($event)" [(value)]="selectedMake" name="make" placeholder="{{Translate('Select Make')}}">
          <mat-option *ngFor="let make of _dropDownLists.makeList" [value]="make">
            {{ make.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="search-input">
        <mat-select  [(ngModel)]="selectedModel" name="model" placeholder="{{Translate('Select Model')}}">
          <mat-option *ngFor="let model of modelList" [value]="make">
            {{ model.Title }}
          </mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="Component Type" #componsntTypes >
          <mat-option [value]="type.Title" *ngFor="let type of _componentservice.componentTypeList">
            {{type.Title}}
          </mat-option>
        </mat-select>
      </mat-form-field> -->


      
      <div class="flex-horizontal set-margin">
    
        <mat-form-field class="input-full-width">
          <input matInput placeholder="{{ 'Make' | translate | async }}" [(ngModel)]="selectedMake" [disabled]="true">
        </mat-form-field>
    
        

        <mat-form-field class="input-full-width ">
          <input matInput placeholder="{{ 'Component Type' | translate | async }}" [(ngModel)]="selectedCompType" [disabled]="true">
        </mat-form-field>
    
        
      </div>
      <mat-form-field class="input-full-width ">
        <input matInput placeholder="{{ 'Model' | translate | async }}" [(ngModel)]="selectedModel" [disabled]="true">
      </mat-form-field>
<div >

  <mat-spinner class="loading-spinner" *ngIf="USCO_PartInfo==null ||TTPartInfo==null "></mat-spinner>
  <div *ngIf="TTPartInfo!=null">
    <span>TrackTreads Part Info</span>
    <table class="table table--striped table--full-width">
      <thead>
        <th>Part #</th>
        <th>USCO #</th>
        <th>Detailed Description</th>
        <!-- <th>Limit Source</th> -->
        <th>Limit Type</th>
        <th>Tool</th>
        <th>Starting Dim</th>
        <th>100% Dim</th>
      </thead>
      <tbody>
        <ng-container *ngIf="InflectionData!=null">
          <tr *ngFor="let info of InflectionData">
            <td>{{PartNo}}</td>
            <td>{{TT_USCOPart}}</td>
            <td>{{TT_PartDesc}}</td>
            <td>Inflection</td>
            <td>{{info.ToolName}}</td>
            <td>{{info.Starting_Dim}}</td>
            <td>{{info.Worn_100}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="LinearData!=null">
          <tr *ngFor="let info of LinearData">
            <td>{{PartNo}}</td>
            <td>{{TT_USCOPart}}</td>
            <td>{{TT_PartDesc}}</td>
            <td>Linear</td>
            <td>{{info.ToolName}}</td>
            <td>{{info.Starting_Dim}}</td>
            <td>{{info.Worn_100}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="PolynomialData!=null">
          <tr *ngFor="let info of PolynomialData">
            <td>{{PartNo}}</td>
            <td>{{TT_USCOPart}}</td>
            <td>{{TT_PartDesc}}</td>
            <td>Polyomial</td>
            <td>{{info.ToolName}}</td>
            <td>{{info.Starting_Dim}}</td>
            <td>{{info.Worn_100}}</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="SteppedData!=null">
          <tr *ngFor="let info of SteppedData">
            <td>{{PartNo}}</td>
            <td>{{TT_USCOPart}}</td>
            <td>{{TT_PartDesc}}</td>
            <td>Stepped</td>
            <td>{{info.ToolName}}</td>
            <td>{{info.Starting_Dim}}</td>
            <td>{{info.Worn_100}}</td>
          </tr>
        </ng-container>
        
      </tbody>
    </table>
  </div>

 

  <div style="margin-top: 3%;" *ngIf="USCO_PartInfo!=null">
    <span>USCO Part Info</span>
    <table class="table table--striped table--full-width">
      <thead>
        <th>USCO #</th>
        <th>Detailed Description</th>
        <th>Tool</th>
        <th>Starting Dim</th>
        <th>100% Dim</th>
      </thead>
      <tbody>
        <tr *ngFor="let data of USCO_PartInfo" (click)="USCOPartRowClick(data)" style="cursor: pointer;">
          <td>{{data.USCOPartNo}}</td>
          <td>{{data.Description}}</td>
          <td>{{data.Tool}}</td>
          <td>{{data.StartinDim}}</td>
          <td>{{data.Dim100Perc}}</td>

        </tr>
      </tbody>
    </table>
  </div>
</div>


<div style="display: flex;flex-direction: row;margin-top: 4%;">

  <mat-form-field class="input-full-width ">
    <input matInput placeholder="{{ 'TT USCO Part NO' | translate | async }}" [(ngModel)]="TT_USCOPart" >
  </mat-form-field>

  <mat-form-field class="input-full-width ">
    <input matInput placeholder="{{ 'USCO Part NO' | translate | async }}" [(ngModel)]="selectedUSCOPart" >
  </mat-form-field>

  <a class="button button--primary" style="margin-right: 20px;    width: 40%; margin-left: 20px;" [hidden]="!isRowClick">
    <i class="material-icons button__icon" [hidden]="!isRowClick"></i><span class="button__text" style="margin-top: -5px;"
      (click)="Update()" [hidden]="!isRowClick">
     Update From USCO</span></a>
</div>
     


  </div>

  <div  class="item-align-end">
    <!-- <button mat-raised-button (click)="onClickStartInspection()">Start Inspection</button> -->
  </div>
</div>